import src from '/Users/huynhducduy/workspace/innosearch/innosearch-fe/interface/src/assets/stores/StoresHeroLandingImage.png?url';

export default {
  lqip: `data:image/png;base64,UklGRtAAAABXRUJQVlA4WAoAAAAQAAAAHwAACwAAQUxQSAoAAAABB9D9iAhERP8DVlA4IKAAAABwBACdASogAAwAPm0skkWkIqGYBABABsSzAE6ZQZDqGExNIOfjVFoZLOdVeAD+9mnuUcAZbmgluU9eB70ItCk5i+QA3ZgEqGQU0oCxBgCOeuvWXDReev/qADC5v6hD9+N4BC/P4i/6L9LuMV66CY7+SKkeMfL+wAQreaTzrt3oHou/Cn15Mt1Y5TpuMd4aYsEvq4ONFmLlTvm2nVAWCxAA`,
  src,
  width: 4317,
  height: 1554,
};
			